import React from 'react';
import { Checkbox } from 'antd';
import type { CheckboxProps } from 'antd';
import styles from './Button.module.css';

interface NSPCheckboxProps extends Omit<CheckboxProps, 'onChange'> {

    label?: React.ReactNode;
    onChange?: (checked: boolean, event: React.ChangeEvent<HTMLInputElement>) => void;
    className?: string;
    checked?: boolean;
    defaultChecked?: boolean;
    disabled?: boolean;
    indeterminate?: boolean;
    style?: React.CSSProperties;
}

export const NSPCheckbox = ({ label,
    onChange,
    className,
    checked,
    defaultChecked,
    disabled = false,
    indeterminate = false,
    style,
    ...restProps
}: NSPCheckboxProps) => {
    const handleChange = (e: any) => {
        if (onChange) {
            onChange(e.target.checked, e);
        }
    };

    const checkboxElement = (
        <Checkbox
            checked={checked}
            defaultChecked={defaultChecked}
            disabled={disabled}
            indeterminate={indeterminate}
            onChange={handleChange}
            className={`nsp-checkbox ${className || ''}`}
            style={style}
            {...restProps}
        />
    );

    // If label is provided, wrap with label text
    if (label) {
        return (
            <Checkbox
                checked={checked}
                defaultChecked={defaultChecked}
                disabled={disabled}
                indeterminate={indeterminate}
                onChange={handleChange}
                className={className || styles.nspcheckbox}
                style={style}
                {...restProps}
            >
                {label}
            </Checkbox>
        );
    }

    return checkboxElement;
};

export default NSPCheckbox;